window.Eventgallery = window.Eventgallery || {};

// the nonce and the folder of the chunks, read while the bundle runs (architecture/frontend.md, "Chunks")
require('./common/js/chunks.js');

require('./frontend/js/EventgalleryBehavior.js');

// the styles of the lightbox, before those of Event Gallery, which change them
require('photoswipe/style.css');

require('./frontend/less/eventgallery.less');


require('./frontend/js/minicart/index');
// the review of the checkout is sent once (data-eg-submit-once)
require('./frontend/js/checkout/submit_once');
require('./frontend/js/socialbutton/index');
require('./frontend/js/jsgallery/index');

// Required Core Stylesheet
import "@glidejs/glide/dist/css/glide.core.css";

